import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent } from './layout/app.layout.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { NotFoundComponent } from './not-found/not-found.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          redirectTo: '/auth/login',
          pathMatch: 'full',
        },
        {
          path: 'auth',
          loadChildren: () =>
            import('./modules/auth/auth.module').then(m => m.AuthModule),
        },
        {
          path: 'app',
          component: AppLayoutComponent,
          canActivate: [AuthGuard],
          children: [
            {
              path: 'dashboard',
              loadChildren: () =>
                import('./modules/dashboard/dashboard.module').then(
                  m => m.DashboardModule
                ),
            },
            {
              path: 'user',
              loadChildren: () =>
                import('./modules/user/user.module').then(m => m.UserModule),
            },
            {
              path: 'lead',
              loadChildren: () =>
                import('./modules/lead/lead.module').then(m => m.LeadModule),
            },
            {
              path: 'client',
              loadChildren: () =>
                import('./modules/client/client.module').then(
                  m => m.ClientModule
                ),
            },
            {
              path: 'schedule',
              loadChildren: () =>
                import('./modules/calendar-workspace/calendar-workspace.module').then(
                  m => m.CalendarWorkspaceModule
                ),
            },
            {
              path: 'calendar',
              loadChildren: () =>
                import('./modules/calendar/calendar.module').then(
                  m => m.CalendarModule
                ),
            },
            {
              path: 'job',
              loadChildren: () =>
                import('./modules/job/job.module').then(m => m.JobModule),
            },
            {
              path: 'quotation',
              loadChildren: () =>
                import('./modules/quotation/quotation.module').then(
                  m => m.QuotationModule
                ),
            },
            {
              path: 'pipeline',
              loadChildren: () =>
                import('./modules/pipeline/pipeline.module').then(
                  m => m.PipelineModule
                ),
            },
            {
              path: 'invoice',
              loadChildren: () =>
                import('./modules/invoice/invoice.module').then(
                  m => m.InvoiceModule
                ),
            },
            {
              path: 'task',
              loadChildren: () =>
                import('./modules/task/task.module').then(m => m.TaskModule),
            },
            {
              path: 'inventory',
              loadChildren: () =>
                import('./modules/inventory/inventory.module').then(
                  m => m.InventoryModule
                ),
            },
            {
              path: 'billing',
              loadChildren: () =>
                import('./modules/billing/billing.module').then(
                  m => m.BillingModule
                ),
            },
            {
              path: 'job-billing',
              loadChildren: () =>
                import('./modules/job-billing/job-billing.module').then(
                  m => m.JobBillingModule
                ),
            },
            {
              path: 'billing-v2',
              loadChildren: () =>
                import('./modules/billing-v2/billing-v2.module').then(
                  m => m.BillingV2Module
                ),
            },
            {
              path: 'lifecycle',
              loadChildren: () =>
                import('./modules/lifecycle/lifecycle.module').then(
                  m => m.LifecycleModule
                ),
            },
            {
              path: 'holiday',
              loadChildren: () =>
                import('./modules/holiday/holiday.module').then(
                  m => m.HolidayModule
                ),
            },
            {
              path: 'not-found',
              component: NotFoundComponent,
            },
            {
              path: 'access-denied',
              component: AccessDeniedComponent,
            },
          ],
        },
        { path: 'notfound', redirectTo: '/app/not-found' },
        { path: '**', redirectTo: '/app/not-found' },
      ],
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'ignore',
      }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
